import React, { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import { toast } from "react-toastify";
import TextInput from "../../../../UI/TextInput";
import { useFormik } from "formik";
import { createValidationSchema } from "../../../../../utils/validatorSchema";
import {
  savedGiftcardApi,
} from "../../../../../services/auth";
import { IMAGE_URL_CONFIG } from "../../../../../constants/url";
import { getSavedGiftCardsWatcher } from "../../../../../store/auth/action";

interface IAddProps {
  onReset: () => void;
}

const AddCard: FC<IAddProps> = ({ onReset }) => {
  const { countryId, userDetails } = useSelector((state: RootState) => ({
    countryId: state.applicationReducer.countryId,
    userDetails: state.authReducer.userDetails,
  }));

  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [addAnother, setAddAnother] = useState(false);


  const getGiftCards = () => {
    dispatch(
        getSavedGiftCardsWatcher({
            memberRefId: userDetails?.result?.memberRefId!,
            countryId: countryId,
            emailId: userDetails?.email!,
        })
    );
}


  const {
    handleChange,
    handleSubmit,
    values,
    errors,
    touched,
    resetForm,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: createValidationSchema(
      "saveGiftCardMethod"
    ),
    initialValues: {
      cardNumber: "",
      Id: "",
    },
    onSubmit: async (values) => {
      let payload: any = {
        countryId: countryId,
        emailId: userDetails?.email!,
        NumberLastDigits: values.cardNumber ? values.cardNumber.slice(-4) : "",
        memberRefId: userDetails?.result?.memberRefId!,
        cardNumber: values.cardNumber,
        status: "insert",
        Id: undefined
      };

      const {
        data: { statusCode, data },
      } = (await savedGiftcardApi(payload)) as any;
      if (statusCode && statusCode === true) {
        toast.success(
          "Gift Card added successfully."
        );
        if (!addAnother) {
          onReset();
        }
        getGiftCards();
        resetForm();

      } else {
        toast.error(
          data ? data : `Error in adding card.`
        );
      }
    },
  });

  const saveAddCard = () => {
    setAddAnother(true);
    handleSubmit()
  }

  return (
    <div className="row my-4 add-gift-card">
      <div className="col-md-12">
        <div className="login-form row">
          <div className="col-12 col-md-6">
            <label className="form-label">GIFT CARD NUMBER*</label>
            <div className="form-group">
              <TextInput
                type="text"
                value={values.cardNumber}
                field={"cardNumber"}
                handleChange={handleChange}
                touched={touched.cardNumber!}
                error={errors.cardNumber}
              />
            </div>
          </div>

          <div className="col-md-12 text-center error_message">
            <span>{errorMessage}</span>
          </div>
          <div className="col-md-12 popup_center_btns">
            <div className="movie_button_wrap">
              <button className="btn gray_btn" onClick={saveAddCard}>
                <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'plus_16x16_white.svg'} /> Save & Add Another
              </button>
              <button
                className="btn gray_btn"
                onClick={() => {
                  setAddAnother(false)
                  handleSubmit()
                }}
              >
                <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'tick_white_icon.svg'} />
                Add Gift Card
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCard;
